<template>
  <div class="body">
      <Headtow></Headtow>
      <Headfor></Headfor>

      <div id="w-center">
        <div class="index_pub_title">
            <p class="pub_d_title">同类图书馆</p>
            <router-link :to="`/index`" class="pub_duo pub_duo_d">
               <i class="el-icon-house size-icon"></i> 首页>同类图书馆
            </router-link>
            <div class="pub_xian"></div>
        </div>
        <ul class="tsg_ul">
          <li class="tsg_li"  v-for="(item, index) in list">
            <router-link :to="`/TlproCont?id=`+item.id" class="pub_duo">
              <img :src="item.picurl" alt="" class="tsg_li_img">
              <p class="tsg_li_title">{{item.title}}</p>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="h-15"></div>

      <div class="page">
        <!-- <el-pagination
          background
          layout="prev, pager, next"
          :page-size="12"
          :page-sizes="[100, 200, 300, 400]"
          @current-change="handleCurrentChange"
          :total="total">
        </el-pagination> -->

        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[20, 50,80,100]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>


      </div>


       <Foot></Foot>
  </div>

</template>

<script>
import headtow from '@/components/public/headtow.vue';
import headfor from '@/components/public/headfor.vue'
import foot from '@/components/public/foot.vue'
export default{
  data(){
    return {
      loading:true,

       list:[],
       page:1,
       total:0,
       size:20,
    }
  },
  components: {
    'Headtow': headtow,  //将别名demo 变成 组件 Demo
    'Headfor': headfor,
    'Foot': foot,
  },
  mounted(){
    this.id = this.$route.query.id;
    this.recordapi();
  },
  methods:{
    recordapi(){
        var that = this;
        var userid = that.$cookieStore.getCookie('userid');
        that.$api.post("/index/tlprolist",{'page':this.page,'keyword':this.keywords,'size':this.size}).then(res => {
          console.log(res);
          // that.types= res.type;
          // that.orderlist= res.orderlist;
          that.list= res.list.data;
          that.total = res.list.total

          that.loading = false
        });
    },
    handleSizeChange(val) {
       this.size = val
       console.log(val);
       this.recordapi();
    },

    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.recordapi();
    },
  }

 }
</script>

<style scoped>
	.tsg_li{width: 276px}
  .tsg_li:nth-child(3n){margin-right: 30px;}
   .tsg_li:nth-child(4n){margin-right: 0px;}
   .tsg_li_img{width: 100%;}
</style>




// WEBPACK FOOTER //
// src/components/Tlpro.vue